module.exports = __webpack_public_path__ + "static/media/sustainable-development-goal-horizontal.5b74f953.svg";